import * as Location from 'expo-location';
import { noteGeolocationPermissionGranted } from './locationAvailability';

export type UserGeoCoords = {
  latitude: number;
  longitude: number;
  accuracy: number | null;
};

/**
 * Pide permiso de ubicación en primer plano y devuelve la posición actual.
 * Funciona en web (navegador), iOS y Android con expo-location.
 */
export async function getCurrentUserPosition(): Promise<UserGeoCoords> {
  const { status } = await Location.requestForegroundPermissionsAsync();
  if (status !== Location.PermissionStatus.GRANTED) {
    throw new Error(
      'Permiso de ubicación denegado. Activa la ubicación para este sitio o la app en ajustes.'
    );
  }
  await noteGeolocationPermissionGranted();

  const pos = await Location.getCurrentPositionAsync({
    accuracy: Location.Accuracy.Balanced,
  });

  return {
    latitude: pos.coords.latitude,
    longitude: pos.coords.longitude,
    accuracy: pos.coords.accuracy ?? null,
  };
}
